module.exports = __webpack_public_path__ + "static/media/victoria_guareschi.f896bd7e.png";